import { render } from "./Header.vue?vue&type=template&id=a2bf0acc"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=a2bf0acc&lang=scss"

import exportComponent from "/home/runner/work/emoemoji/emoemoji/vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__